"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.useStore = void 0;
const react_1 = require("react");
const module_1 = require("./module");
function useStore(store, stateSelector) {
    const [state, setState] = (0, react_1.useState)(store.getCurrentState(stateSelector));
    const isMounted = (0, react_1.useRef)(true);
    // Subscribe to store only once
    const unsub = (0, react_1.useMemo)(() => {
        return store.subscribe(stateSelector, (nextState) => {
            // Prevent subscriber from updating state after component has unmounted
            if (!isMounted.current) {
                return;
            }
            setState((_) => nextState);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        // Unsubscribe from store on unmount
        return () => {
            isMounted.current = false;
            unsub();
        };
    }, []);
    return state;
}
exports.useStore = useStore;
class Store extends module_1.Store {
    constructor() {
        super(...arguments);
        this.useState = (stateSelector) => {
            return useStore(this, stateSelector);
        };
    }
}
exports.Store = Store;
